import React from 'react';
import { Box } from '@mui/material/';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { BrowserView, MobileView } from 'react-device-detect';

const f3 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E1%20Floor%203.png?alt=media&token=1112ec36-6c59-461b-a274-8f459f32e6f5";

export default function bsoeF1() {
    return (
        <>
            <BrowserView>
                <Box marginLeft={50} marginTop={0.5}>
                    <TransformWrapper>
                        <TransformComponent>
                            <img src={f3} alt="f3" width={855} height={555} />
                        </TransformComponent>
                    </TransformWrapper>
                </Box>
            </BrowserView>
            <MobileView>
                <Box marginTop={1} marginBottom={5} display="flex" justifyContent="center" alignItems="center">
                    <TransformWrapper>
                        <TransformComponent>
                            <img src={f3} alt="f3" width={342} height={222} />
                        </TransformComponent>
                    </TransformWrapper>
                </Box>
            </MobileView>
        </>
    );
}
